// extracted by mini-css-extract-plugin
export var lg = "_3i-4";
export var md = "_3i-3";
export var sm = "_3i-2";
export var xs = "_3i-1";
export var xxs = "_3i-0";